/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyOtpRouteImport } from './routes/verify-otp'
import { Route as VerifyDomainRouteImport } from './routes/verify-domain'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as PortalSettingsRouteImport } from './routes/portal/settings'
import { Route as PortalSendersRouteImport } from './routes/portal/senders'
import { Route as PortalReportsRouteImport } from './routes/portal/reports'
import { Route as PortalProtectionRouteImport } from './routes/portal/protection'
import { Route as PortalPolicyRouteImport } from './routes/portal/policy'
import { Route as PortalFailuresRouteImport } from './routes/portal/failures'
import { Route as PortalDomainsRouteImport } from './routes/portal/domains'
import { Route as PortalAlertsRouteImport } from './routes/portal/alerts'
import { Route as PortalActionCenterRouteImport } from './routes/portal/action-center'
import { Route as PortalSendersIndexRouteImport } from './routes/portal/senders.index'
import { Route as PortalReportsIndexRouteImport } from './routes/portal/reports.index'
import { Route as PortalDomainsIndexRouteImport } from './routes/portal/domains.index'
import { Route as PortalSendersSourceIpRouteImport } from './routes/portal/senders.$sourceIp'
import { Route as PortalReportsReportIdRouteImport } from './routes/portal/reports.$reportId'
import { Route as PortalDomainsDomainIdRouteImport } from './routes/portal/domains.$domainId'

const VerifyOtpRoute = VerifyOtpRouteImport.update({
  id: '/verify-otp',
  path: '/verify-otp',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyDomainRoute = VerifyDomainRouteImport.update({
  id: '/verify-domain',
  path: '/verify-domain',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSettingsRoute = PortalSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSendersRoute = PortalSendersRouteImport.update({
  id: '/senders',
  path: '/senders',
  getParentRoute: () => PortalRoute,
} as any)
const PortalReportsRoute = PortalReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => PortalRoute,
} as any)
const PortalProtectionRoute = PortalProtectionRouteImport.update({
  id: '/protection',
  path: '/protection',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPolicyRoute = PortalPolicyRouteImport.update({
  id: '/policy',
  path: '/policy',
  getParentRoute: () => PortalRoute,
} as any)
const PortalFailuresRoute = PortalFailuresRouteImport.update({
  id: '/failures',
  path: '/failures',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDomainsRoute = PortalDomainsRouteImport.update({
  id: '/domains',
  path: '/domains',
  getParentRoute: () => PortalRoute,
} as any)
const PortalAlertsRoute = PortalAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => PortalRoute,
} as any)
const PortalActionCenterRoute = PortalActionCenterRouteImport.update({
  id: '/action-center',
  path: '/action-center',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSendersIndexRoute = PortalSendersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalSendersRoute,
} as any)
const PortalReportsIndexRoute = PortalReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalReportsRoute,
} as any)
const PortalDomainsIndexRoute = PortalDomainsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalDomainsRoute,
} as any)
const PortalSendersSourceIpRoute = PortalSendersSourceIpRouteImport.update({
  id: '/$sourceIp',
  path: '/$sourceIp',
  getParentRoute: () => PortalSendersRoute,
} as any)
const PortalReportsReportIdRoute = PortalReportsReportIdRouteImport.update({
  id: '/$reportId',
  path: '/$reportId',
  getParentRoute: () => PortalReportsRoute,
} as any)
const PortalDomainsDomainIdRoute = PortalDomainsDomainIdRouteImport.update({
  id: '/$domainId',
  path: '/$domainId',
  getParentRoute: () => PortalDomainsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRouteWithChildren
  '/verify-domain': typeof VerifyDomainRoute
  '/verify-otp': typeof VerifyOtpRoute
  '/portal/action-center': typeof PortalActionCenterRoute
  '/portal/alerts': typeof PortalAlertsRoute
  '/portal/domains': typeof PortalDomainsRouteWithChildren
  '/portal/failures': typeof PortalFailuresRoute
  '/portal/policy': typeof PortalPolicyRoute
  '/portal/protection': typeof PortalProtectionRoute
  '/portal/reports': typeof PortalReportsRouteWithChildren
  '/portal/senders': typeof PortalSendersRouteWithChildren
  '/portal/settings': typeof PortalSettingsRoute
  '/portal/': typeof PortalIndexRoute
  '/portal/domains/$domainId': typeof PortalDomainsDomainIdRoute
  '/portal/reports/$reportId': typeof PortalReportsReportIdRoute
  '/portal/senders/$sourceIp': typeof PortalSendersSourceIpRoute
  '/portal/domains/': typeof PortalDomainsIndexRoute
  '/portal/reports/': typeof PortalReportsIndexRoute
  '/portal/senders/': typeof PortalSendersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/verify-domain': typeof VerifyDomainRoute
  '/verify-otp': typeof VerifyOtpRoute
  '/portal/action-center': typeof PortalActionCenterRoute
  '/portal/alerts': typeof PortalAlertsRoute
  '/portal/failures': typeof PortalFailuresRoute
  '/portal/policy': typeof PortalPolicyRoute
  '/portal/protection': typeof PortalProtectionRoute
  '/portal/settings': typeof PortalSettingsRoute
  '/portal': typeof PortalIndexRoute
  '/portal/domains/$domainId': typeof PortalDomainsDomainIdRoute
  '/portal/reports/$reportId': typeof PortalReportsReportIdRoute
  '/portal/senders/$sourceIp': typeof PortalSendersSourceIpRoute
  '/portal/domains': typeof PortalDomainsIndexRoute
  '/portal/reports': typeof PortalReportsIndexRoute
  '/portal/senders': typeof PortalSendersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRouteWithChildren
  '/verify-domain': typeof VerifyDomainRoute
  '/verify-otp': typeof VerifyOtpRoute
  '/portal/action-center': typeof PortalActionCenterRoute
  '/portal/alerts': typeof PortalAlertsRoute
  '/portal/domains': typeof PortalDomainsRouteWithChildren
  '/portal/failures': typeof PortalFailuresRoute
  '/portal/policy': typeof PortalPolicyRoute
  '/portal/protection': typeof PortalProtectionRoute
  '/portal/reports': typeof PortalReportsRouteWithChildren
  '/portal/senders': typeof PortalSendersRouteWithChildren
  '/portal/settings': typeof PortalSettingsRoute
  '/portal/': typeof PortalIndexRoute
  '/portal/domains/$domainId': typeof PortalDomainsDomainIdRoute
  '/portal/reports/$reportId': typeof PortalReportsReportIdRoute
  '/portal/senders/$sourceIp': typeof PortalSendersSourceIpRoute
  '/portal/domains/': typeof PortalDomainsIndexRoute
  '/portal/reports/': typeof PortalReportsIndexRoute
  '/portal/senders/': typeof PortalSendersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/portal'
    | '/verify-domain'
    | '/verify-otp'
    | '/portal/action-center'
    | '/portal/alerts'
    | '/portal/domains'
    | '/portal/failures'
    | '/portal/policy'
    | '/portal/protection'
    | '/portal/reports'
    | '/portal/senders'
    | '/portal/settings'
    | '/portal/'
    | '/portal/domains/$domainId'
    | '/portal/reports/$reportId'
    | '/portal/senders/$sourceIp'
    | '/portal/domains/'
    | '/portal/reports/'
    | '/portal/senders/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/verify-domain'
    | '/verify-otp'
    | '/portal/action-center'
    | '/portal/alerts'
    | '/portal/failures'
    | '/portal/policy'
    | '/portal/protection'
    | '/portal/settings'
    | '/portal'
    | '/portal/domains/$domainId'
    | '/portal/reports/$reportId'
    | '/portal/senders/$sourceIp'
    | '/portal/domains'
    | '/portal/reports'
    | '/portal/senders'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/portal'
    | '/verify-domain'
    | '/verify-otp'
    | '/portal/action-center'
    | '/portal/alerts'
    | '/portal/domains'
    | '/portal/failures'
    | '/portal/policy'
    | '/portal/protection'
    | '/portal/reports'
    | '/portal/senders'
    | '/portal/settings'
    | '/portal/'
    | '/portal/domains/$domainId'
    | '/portal/reports/$reportId'
    | '/portal/senders/$sourceIp'
    | '/portal/domains/'
    | '/portal/reports/'
    | '/portal/senders/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  PortalRoute: typeof PortalRouteWithChildren
  VerifyDomainRoute: typeof VerifyDomainRoute
  VerifyOtpRoute: typeof VerifyOtpRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-otp': {
      id: '/verify-otp'
      path: '/verify-otp'
      fullPath: '/verify-otp'
      preLoaderRoute: typeof VerifyOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-domain': {
      id: '/verify-domain'
      path: '/verify-domain'
      fullPath: '/verify-domain'
      preLoaderRoute: typeof VerifyDomainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/settings': {
      id: '/portal/settings'
      path: '/settings'
      fullPath: '/portal/settings'
      preLoaderRoute: typeof PortalSettingsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/senders': {
      id: '/portal/senders'
      path: '/senders'
      fullPath: '/portal/senders'
      preLoaderRoute: typeof PortalSendersRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/reports': {
      id: '/portal/reports'
      path: '/reports'
      fullPath: '/portal/reports'
      preLoaderRoute: typeof PortalReportsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/protection': {
      id: '/portal/protection'
      path: '/protection'
      fullPath: '/portal/protection'
      preLoaderRoute: typeof PortalProtectionRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/policy': {
      id: '/portal/policy'
      path: '/policy'
      fullPath: '/portal/policy'
      preLoaderRoute: typeof PortalPolicyRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/failures': {
      id: '/portal/failures'
      path: '/failures'
      fullPath: '/portal/failures'
      preLoaderRoute: typeof PortalFailuresRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/domains': {
      id: '/portal/domains'
      path: '/domains'
      fullPath: '/portal/domains'
      preLoaderRoute: typeof PortalDomainsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/alerts': {
      id: '/portal/alerts'
      path: '/alerts'
      fullPath: '/portal/alerts'
      preLoaderRoute: typeof PortalAlertsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/action-center': {
      id: '/portal/action-center'
      path: '/action-center'
      fullPath: '/portal/action-center'
      preLoaderRoute: typeof PortalActionCenterRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/senders/': {
      id: '/portal/senders/'
      path: '/'
      fullPath: '/portal/senders/'
      preLoaderRoute: typeof PortalSendersIndexRouteImport
      parentRoute: typeof PortalSendersRoute
    }
    '/portal/reports/': {
      id: '/portal/reports/'
      path: '/'
      fullPath: '/portal/reports/'
      preLoaderRoute: typeof PortalReportsIndexRouteImport
      parentRoute: typeof PortalReportsRoute
    }
    '/portal/domains/': {
      id: '/portal/domains/'
      path: '/'
      fullPath: '/portal/domains/'
      preLoaderRoute: typeof PortalDomainsIndexRouteImport
      parentRoute: typeof PortalDomainsRoute
    }
    '/portal/senders/$sourceIp': {
      id: '/portal/senders/$sourceIp'
      path: '/$sourceIp'
      fullPath: '/portal/senders/$sourceIp'
      preLoaderRoute: typeof PortalSendersSourceIpRouteImport
      parentRoute: typeof PortalSendersRoute
    }
    '/portal/reports/$reportId': {
      id: '/portal/reports/$reportId'
      path: '/$reportId'
      fullPath: '/portal/reports/$reportId'
      preLoaderRoute: typeof PortalReportsReportIdRouteImport
      parentRoute: typeof PortalReportsRoute
    }
    '/portal/domains/$domainId': {
      id: '/portal/domains/$domainId'
      path: '/$domainId'
      fullPath: '/portal/domains/$domainId'
      preLoaderRoute: typeof PortalDomainsDomainIdRouteImport
      parentRoute: typeof PortalDomainsRoute
    }
  }
}

interface PortalDomainsRouteChildren {
  PortalDomainsDomainIdRoute: typeof PortalDomainsDomainIdRoute
  PortalDomainsIndexRoute: typeof PortalDomainsIndexRoute
}

const PortalDomainsRouteChildren: PortalDomainsRouteChildren = {
  PortalDomainsDomainIdRoute: PortalDomainsDomainIdRoute,
  PortalDomainsIndexRoute: PortalDomainsIndexRoute,
}

const PortalDomainsRouteWithChildren = PortalDomainsRoute._addFileChildren(
  PortalDomainsRouteChildren,
)

interface PortalReportsRouteChildren {
  PortalReportsReportIdRoute: typeof PortalReportsReportIdRoute
  PortalReportsIndexRoute: typeof PortalReportsIndexRoute
}

const PortalReportsRouteChildren: PortalReportsRouteChildren = {
  PortalReportsReportIdRoute: PortalReportsReportIdRoute,
  PortalReportsIndexRoute: PortalReportsIndexRoute,
}

const PortalReportsRouteWithChildren = PortalReportsRoute._addFileChildren(
  PortalReportsRouteChildren,
)

interface PortalSendersRouteChildren {
  PortalSendersSourceIpRoute: typeof PortalSendersSourceIpRoute
  PortalSendersIndexRoute: typeof PortalSendersIndexRoute
}

const PortalSendersRouteChildren: PortalSendersRouteChildren = {
  PortalSendersSourceIpRoute: PortalSendersSourceIpRoute,
  PortalSendersIndexRoute: PortalSendersIndexRoute,
}

const PortalSendersRouteWithChildren = PortalSendersRoute._addFileChildren(
  PortalSendersRouteChildren,
)

interface PortalRouteChildren {
  PortalActionCenterRoute: typeof PortalActionCenterRoute
  PortalAlertsRoute: typeof PortalAlertsRoute
  PortalDomainsRoute: typeof PortalDomainsRouteWithChildren
  PortalFailuresRoute: typeof PortalFailuresRoute
  PortalPolicyRoute: typeof PortalPolicyRoute
  PortalProtectionRoute: typeof PortalProtectionRoute
  PortalReportsRoute: typeof PortalReportsRouteWithChildren
  PortalSendersRoute: typeof PortalSendersRouteWithChildren
  PortalSettingsRoute: typeof PortalSettingsRoute
  PortalIndexRoute: typeof PortalIndexRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalActionCenterRoute: PortalActionCenterRoute,
  PortalAlertsRoute: PortalAlertsRoute,
  PortalDomainsRoute: PortalDomainsRouteWithChildren,
  PortalFailuresRoute: PortalFailuresRoute,
  PortalPolicyRoute: PortalPolicyRoute,
  PortalProtectionRoute: PortalProtectionRoute,
  PortalReportsRoute: PortalReportsRouteWithChildren,
  PortalSendersRoute: PortalSendersRouteWithChildren,
  PortalSettingsRoute: PortalSettingsRoute,
  PortalIndexRoute: PortalIndexRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  PortalRoute: PortalRouteWithChildren,
  VerifyDomainRoute: VerifyDomainRoute,
  VerifyOtpRoute: VerifyOtpRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
